import { Box, ButtonBase, makeStyles, Typography } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import React from "react";

import { WebinarSummary } from "@/api/generated";
import { homeCardStyle } from "@/components/home/HomeSection";
import { layoutTokens as layout, semanticColors as colors, textStyles } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles({
  card: {
    ...homeCardStyle,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    textAlign: "left",
    width: "100%",
    minWidth: 0,
    overflow: "hidden",
  },
  recent: {
    width: 240,
    flexShrink: 0,
    scrollSnapAlign: "start",
    [theme.breakpoints.up("md")]: { width: "calc((100% - 24px) / 2)" },
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: layout.radius.md,
    "& $thumbnail": { width: "42%", maxWidth: 142, flexShrink: 0 },
    "& $title": textStyles["SP/Button/M"],
  },
  responsiveRow: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      alignItems: "center",
      borderRadius: layout.radius.md,
      "& $thumbnail": { width: 142, flexShrink: 0 },
      "& $title": textStyles["SP/Button/M"],
    },
  },
  thumbnail: {
    position: "relative",
    width: "100%",
    aspectRatio: "16 / 9",
    backgroundColor: colors["surface/inverse"],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  image: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" },
  play: {
    position: "relative",
    borderRadius: layout.radius.full,
    width: 40,
    height: 40,
    color: colors["text/primary"],
    backgroundColor: colors["surface/card"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: layout.space[4],
    padding: `${layout.space[12]}px ${layout.space[12]}px ${layout.space[16]}px`,
    minWidth: 0,
    flex: 1,
  },
  title: {
    ...textStyles["SP/Heading/H4"],
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    overflowWrap: "anywhere",
  },
  tag: { ...textStyles["SP/Body/Small"], color: colors["text/secondary"] },
});

const tagLabels = { beginner: "初心者向け", intermediate: "中級者向け", advanced: "上級者向け" };
export const ExclusiveVideoCard: React.FC<{
  webinar: WebinarSummary;
  onClick: () => void;
  variant?: "recent" | "list" | "next";
}> = ({ webinar, onClick, variant = "list" }) => {
  const classes = useStyles();
  return (
    <ButtonBase
      className={`${classes.card} ${variant === "recent" ? classes.recent : variant === "next" ? classes.row : classes.responsiveRow}`}
      disabled={!webinar.id}
      onClick={onClick}
      aria-label={`${webinar.title || "動画"}を見る`}
    >
      <Box className={classes.thumbnail}>
        {webinar.thumbnail_url && <img className={classes.image} src={webinar.thumbnail_url} alt="" loading="lazy" />}
        <Box className={classes.play}>
          <PlayArrowIcon />
        </Box>
      </Box>
      <Box className={classes.body}>
        <Typography className={classes.title}>{webinar.title || "-"}</Typography>
        {webinar.tag && tagLabels[webinar.tag] && (
          <Typography className={classes.tag}>{tagLabels[webinar.tag]}</Typography>
        )}
      </Box>
    </ButtonBase>
  );
};
